/** Close code the support gateway uses to refuse a handshake outright. */
export const SUPPORT_SOCKET_UNAUTHORIZED = 4401;

/**
 * Where the support chat socket lives, derived from the API base rather than
 * a second environment variable — one base URL per environment is already
 * configured and correct, and a separate socket URL is one more thing to get
 * wrong when an environment moves.
 *
 * Returns null when there is no token: an unauthenticated socket would be
 * refused by the gateway, and react-use-websocket treats a null url as
 * "don't connect", which is exactly the wanted behaviour before sign-in.
 */
export function supportSocketUrl(
  baseUrl: string | undefined,
  token: string | null,
): string | null {
  if (!baseUrl || !token) return null;

  const wsBase = baseUrl.replace(/^http/, 'ws').replace(/\/+$/, '');
  return `${wsBase}/_ws/support?token=${encodeURIComponent(token)}`;
}

/**
 * Whether a closed socket is worth retrying.
 *
 * A refused handshake must not be retried: the token is wrong or the account
 * lost the permission, and reconnecting only produces an endless auth loop
 * against the server. Every other close — a Cloud Run request timeout, a
 * dropped network, a deploy — is transient and must reconnect, or an agent's
 * chat silently stops updating while still looking open.
 */
export function shouldReconnectSupportSocket(event: { code?: number }): boolean {
  return event?.code !== SUPPORT_SOCKET_UNAUTHORIZED;
}
